import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import API_URLS from './apiConfig';

const ValuesComponent = (props) => {
  const values = props.secvalues;
  const title = props.title;
  const id = props.id;
  const [visibleIndexes, setVisibleIndexes] = useState([]);
  const sectionRef = useRef(null);
  //console.log(values);
  // useEffect(() => {
  //   const fetchValues = async () => {
  //     try {
  //       const response = await axios.get(API_URLS.getValuesPurpose);
  //       const fetchedValues = response.data.posts[3].values;  // Assuming the values are in the 4th post
  //       setValues(fetchedValues);  // Update state with the fetched values
  //     } catch (error) {
  //       console.error("Error fetching values data:", error);
  //     }
  //   };

  //   fetchValues();
  // }, []);

  useEffect(() => {
    // Intersection Observer for revealing values with a delay
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          values.forEach((_, index) =>
            setTimeout(() => {
              setVisibleIndexes((prev) => [...prev, index]);
            }, index * 300)
          );
          observer.disconnect();
        }
      },
      { threshold: 0.5 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => observer.disconnect();
  }, [values]);
  

  return (
    <div id={`section-${id}`} className="section values" data-id={id}>
      <h1 className="section-common-title">{title}</h1>  
      <div className="values-container" ref={sectionRef}>
        {values.map((value, index) => (
          <div
            className={`value-item ${visibleIndexes.includes(index) ? "visible" : ""}`}
            key={index}
          >
            <div className="value-letter">{value.title}</div> 
            <div className="value-text">{value.description}</div> 
          </div>
        ))}
      </div>
    </div>
  );
};

export default ValuesComponent;
